import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import "./quizSettingsPage.css";
import { fetchThemeData } from "../../themeSlice";
import { selectAdminToken } from "../../sessionSlice";
import { useNavigate } from "react-router-dom";
import { updateThemeData } from "../../functions/updateThemeData";

const QUESTION_TIMER_MAX_SECONDS = 300;

const QuizSettingsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminToken = useSelector(selectAdminToken);
  const { currentTheme, data: themeData } = useSelector((state) => state.theme);

  const [wmlQuestionTimerSeconds, setWmlQuestionTimerSeconds] = useState("0");

  useEffect(() => {
    if (!themeData) return;
    const t = parseInt(themeData.wmlQuestionTimerSeconds, 10);
    const ts = Number.isNaN(t)
      ? 30
      : Math.min(QUESTION_TIMER_MAX_SECONDS, Math.max(0, t));
    setWmlQuestionTimerSeconds(String(ts));
  }, [themeData, currentTheme]);

  useEffect(() => {
    dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch, currentTheme]);

  const handleSubmit = async () => {
    const sanitize = (v, def, min = null, max = null) => {
      const n = parseInt(v, 10);
      if (Number.isNaN(n)) return def;
      if (min !== null && n < min) return min;
      if (max !== null && n > max) return max;
      return n;
    };

    const timerSec = sanitize(
      wmlQuestionTimerSeconds,
      30,
      1,
      QUESTION_TIMER_MAX_SECONDS
    );

    const payload = {
      data: {
        wmlQuestionTimerSeconds: String(timerSec),
      },
      currentTheme,
    };

    try {
      await updateThemeData({ payload, token: adminToken });
      Swal.fire("Success", "Settings saved!", "success");
      navigate("/admin/quiz-settings");
      window.location.reload();
    } catch (e) {
      Swal.fire("Error", e.message || "Failed to save settings", "error");
    }
  };

  return (
    <>
      <div className="back-button-holder">
        <button
          className="back-button"
          onClick={() => navigate("/admin/questions")}
        >
          <i class="fa-solid fa-arrow-left"></i> Back
        </button>
      </div>
      <div className="rules-page-new">
        <div className="blue-tabs-container">
          <div className="blue-tabs"></div>
          <div className="blue-tabs"></div>
          <div className="blue-tabs blue-tabs-active"></div>
        </div>

        <div className="admin-tabs-holder-v2">
          <div className="tabs-main-title">Settings</div>
          <div className="admin-tab-container">
            <div className="admin-tab-title">
              <i className="fa-solid fa-gear"></i> &nbsp; Question Timer
            </div>
            <div className="form-group-v1">
              <label>Release question timer (seconds)</label>
              <input
                type="number"
                min="1"
                max={QUESTION_TIMER_MAX_SECONDS}
                value={wmlQuestionTimerSeconds}
                onChange={(e) => {
                  const raw = e.target.value;
                  if (raw === "") {
                    setWmlQuestionTimerSeconds("");
                    return;
                  }
                  const n = parseInt(raw, 10);
                  if (Number.isNaN(n)) return;
                  setWmlQuestionTimerSeconds(
                    String(
                      Math.min(QUESTION_TIMER_MAX_SECONDS, Math.max(0, n))
                    )
                  );
                }}
                onBlur={() => {
                  if (wmlQuestionTimerSeconds === "") setWmlQuestionTimerSeconds("30");
                }}
              />
              <div className="code">
                This value controls the live game countdown after host clicks
                &quot;Release Question&quot;. Default is 30 seconds.
              </div>
            </div>
          </div>

          <div className="rules-action-holder">
            <button className="save-and-continue" onClick={handleSubmit}>
              Save Settings
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuizSettingsPage;
